import React from "react";
import { Box, Grid, Typography, List, ListItem } from "@mui/material";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import KeyboardDoubleArrowLeftIcon from "@mui/icons-material/KeyboardDoubleArrowLeft";
import SampleImage from "../../../src/assets/images/site/asic_design.jpg";
import ServiceImage from "../../../src/assets/images/site/asic-img2.png";
import PhyelementsMain from "../PhyElements/PhyelementsMain";
import "./OurServices.css";
import SiteFooter from "./ASIC/SiteFooter";

function DesignLayout() {
  return (
    <Box style={{ backgroundColor: "#f9f9f9" }}>
      <Box sx={{ flex: 1 }}>
        <PhyelementsMain />

        {/* ---------- MIDDLE SECTION ---------- */}
        <Grid className="middle-section-title">
          DESIGN AND LAYOUT CAPABILITIES
        </Grid>

        <Grid
          className="middle-section-content"
          container
          sx={{ display: "flex", flexDirection: "row" }}
        >
          <Grid
            className="middle-section-points"
            item
            xs={12}
            md={4.5}
            order={{ xs: 2, md: 1 }}
            sx={{paddingRight:{xs:"20px",md:"0px"}}}
          >
            <List>
              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowRightIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Memory
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We design and develop high-performance memory solutions,
                    including SRAM, register files, and custom memory
                    architectures. Our expertise spans optimization for power,
                    performance, and area (PPA) across multiple technology
                    nodes, along with support for both compiler-based and fully
                    customized memory designs.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowRightIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Embedded Non-Volatile Memory (eNVM)
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    Our team delivers robust eNVM solutions, including Flash,
                    EEPROM, and emerging non-volatile technologies. We focus on
                    reliability, endurance, and data retention, ensuring
                    seamless integration with process technologies and enabling
                    low-power, high-efficiency embedded applications.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowRightIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Analog
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    Our team specializes in precision analog layout design with
                    a strong focus on matching, symmetry, and noise
                    minimization. We support a wide range of analog circuits,
                    ensuring high performance, reliability, and compliance with
                    process-specific layout guidelines.
                  </Typography>
                </Box>
              </ListItem>
              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Input/Output (I/O)
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We provide design and development of reliable I/O
                    interfaces, including GPIO and high-speed, low-power I/Os.
                    Our solutions emphasize signal integrity, ESD protection,
                    and compliance with process-specific requirements,
                    supporting both standard and custom interface needs.
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </Grid>

          <Grid
            className="middle-section-image"
            item
            xs={4}
            md={2}
            order={{ xs: 1, md: 2 }}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              alignSelf: "center"
            }}
          >
            <img src={ServiceImage} alt="Service" />
          </Grid>

          <Grid
            className="middle-section-points"
            item
            xs={12}
            md={4.5}
            order={{ xs: 3, md: 3 }}
            sx={{paddingRight:{xs:"20px",md:"0px"}}}
          >
            <List>
              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Standard Cell
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We offer comprehensive standard cell library development and
                    characterization services across various technology nodes.
                    Our designs are optimized for timing, power, and area, with
                    full support for multiple Vt options, ensuring high-quality
                    libraries for efficient digital design implementation.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    Radio Frequency (RF)
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We offer specialized RF layout design with a focus on
                    parasitic control, isolation, and high-frequency
                    performance. Our expertise enables accurate implementation
                    of RF blocks while maintaining signal integrity and
                    minimizing interference.
                  </Typography>
                </Box>
              </ListItem>

              <ListItem disablePadding sx={{ alignItems: "flex-start" }}>
                <KeyboardDoubleArrowLeftIcon
                  sx={{ color: "#e31837", marginRight: 1 }}
                />
                <Box>
                  <Typography variant="h5" className="services-points-title">
                    3D Integration
                  </Typography>
                  <Typography variant="subtitle" className="services-points">
                    We support advanced layout design for 3D integration
                    technologies, including multi-die and stacked architectures.
                    Our approach addresses interconnect optimization, thermal
                    considerations, and efficient space utilization to enable
                    next-generation high-density designs.
                  </Typography>
                </Box>
              </ListItem>
            </List>
          </Grid>
        </Grid>
      </Box>
      <SiteFooter />
    </Box>
  );
}

export default DesignLayout;
